export { default } from './CarrosEletricosPerguntas';
